/**
 * MyTrainingPanel.jsx: BM-H3630 (5 Oct 2026). "My training" on every dashboard.
 *
 * Vanessa: "add to each person's dashboard and provide deadlines/reminders for
 * annual AML training". Shows each course's status and due date, with a link
 * to take it. Server: GET /api/compliance/training/my.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../config/api";
import { STATUS, statusWords } from "../pages/compliance/Training";

function authHeaders() {
  const id = sessionStorage.getItem("bonsai_user_id") || localStorage.getItem("bonsai_user_id") || "";
  return id ? { "X-Bonsai-User-Id": id } : {};
}

const day = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { dateStyle: "medium" }) : "");

export default function MyTrainingPanel() {
  const [courses, setCourses] = useState(null);
  useEffect(() => {
    axios.get(`${API}/compliance/training/my`, { headers: authHeaders() })
      .then((r) => setCourses(r.data.courses || []))
      .catch(() => setCourses(null));
  }, []);
  if (!courses || courses.length === 0) return null;
  return (
    <section className="rounded-md border border-slate-700/60 bg-slate-900/50 p-4 space-y-2" data-testid="my-training-panel">
      <h2 className="text-sm font-semibold text-slate-100">My training</h2>
      {courses.map((c) => {
        const [label, cls] = STATUS[c.status] || [c.status, ""];
        return (
          <div key={c.course_id} className="flex flex-wrap items-baseline justify-between gap-2">
            <Link to={`/training/${c.course_id}`} className="text-sm text-sky-300">{c.title}</Link>
            <span className={`text-sm ${cls}`} data-testid={`my-training-${c.course_id}`}>
              {c.annual === false ? statusWords(c) : c.status === "current" ? `${label} (next due ${day(c.due)})` : `${label} by ${day(c.due)}`}
            </span>
          </div>
        );
      })}
    </section>
  );
}
